import { addressRouteDescriptors } from "../routes/addresses.js";
import { blockRouteDescriptors } from "../routes/blocks.js";
import { governanceSearchRouteDescriptors } from "../routes/governanceSearch.js";
import { liveRouteDescriptors } from "../routes/live.js";
import { metricsRouteDescriptors } from "../routes/metrics.js";
import { statusRawRouteDescriptors } from "../routes/statusRaw.js";
import { streamRouteDescriptors } from "../routes/stream.js";
import { transactionRouteDescriptors } from "../routes/transactions.js";
import { validatorRouteDescriptors } from "../routes/validators.js";
/**
 * Stable public route catalog for package consumers.
 */
export const routeCatalog = {
    addresses: addressRouteDescriptors,
    blocks: blockRouteDescriptors,
    governanceSearch: governanceSearchRouteDescriptors,
    live: liveRouteDescriptors,
    metrics: metricsRouteDescriptors,
    statusRaw: statusRawRouteDescriptors,
    stream: streamRouteDescriptors,
    transactions: transactionRouteDescriptors,
    validators: validatorRouteDescriptors,
};
//# sourceMappingURL=catalog.js.map